import { __read, __spreadArray } from "tslib";
import { CHANNEL_IO_EVENT_API_NAMES, ChannelIO } from './ChannelIO';
//
//
//
export var _INTERNAL_EVENT_TYPE = 'react-channelio-evt';
export var _INTERNAL_EVENT_API_NAMES = Object.freeze(__spreadArray(__spreadArray([], __read(CHANNEL_IO_EVENT_API_NAMES), false), [
    'onBoot',
], false));
//
//
//
/**
 * [internal] Create dispatching function for internal event.
 */
export function createEventDispatcher(name) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        document.dispatchEvent(new CustomEvent(_INTERNAL_EVENT_TYPE, {
            detail: {
                name: name,
                args: args,
            },
        }));
    };
}
/**
 * [internal] Register event callbacks.
 */
export function registerCallbackEvents() {
    ChannelIO('clearCallbacks');
    setTimeout(function () {
        CHANNEL_IO_EVENT_API_NAMES.forEach(function (method) {
            ChannelIO(method, createEventDispatcher(method));
        });
    });
}
